import React from "react";
import { GlossyThemeProvider } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { Fieldset, Label } from "@ui-kit/form";
import MDEditor from "@uiw/react-md-editor";
import RadarlyCardsMdEditorStyle from "@radarly/components/cards/md-editor-style";
import { tr } from "@radarly/i18n";
import { Card } from "@radarly/models/cards";
import { editTextOnCard } from "@radarly/models/cards/editor";
import { TextCard } from "@radarly/models/cards/model";

export interface PanelsCardEditionSidebarTextProps {
  card: TextCard;
  setCard: (card: Card) => void;
  locale: Locale;
}

const HIDDEN_COMMANDS = [
  "fullscreen",
  "code",
  "codeBlock",
  "image",
  "checked-list",
];

const PanelsCardEditionSidebarOptions = ({
  card,
  setCard,
  locale,
}: PanelsCardEditionSidebarTextProps) => (
  <>
    <Fieldset>
      <Label htmlFor="name">
        {tr(locale, "CUSTOM_PAGES::EDITOR::CARD_LIBRARY::CONTENT")}
      </Label>
    </Fieldset>
    <Fieldset>
      <GlossyThemeProvider name="tile">
        <RadarlyCardsMdEditorStyle />
        <MDEditor
          visiableDragbar={false}
          value={card.dataviz.content}
          height={300}
          preview="edit"
          fullscreen={false}
          extraCommands={[]}
          onChange={(value) => setCard(editTextOnCard(card, value))}
          commandsFilter={(cmd) => {
            if (HIDDEN_COMMANDS.includes(cmd.name)) {
              return false;
            }
            return cmd;
          }}
        />
      </GlossyThemeProvider>
    </Fieldset>
  </>
);

export default PanelsCardEditionSidebarOptions;
